module.exports = __webpack_public_path__ + "img/long2.ca83a859.jpg";